import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Login from '../../components/auth/Login';

const LoginPage: React.FC = () => {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={5}>
          <Card className="shadow-sm my-5">
            <Card.Body className="p-4 p-md-5">
              <h2 className="text-center mb-4">Login</h2>
              <Login />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage; 